import { AbstractControl } from '@angular/forms';

export class PasswordValidator {

  static matchPassword(AC: AbstractControl) {
    // console.log(AC);
    let password = AC.get('password').value; 
    // let oldPassword = AC.get('confirmPassword').value; 
    let confirmPassword = AC.get('confirmPassword').value;

    if (password !== confirmPassword) {
      AC.get('confirmPassword').setErrors({ matchPassword: true });
    } else {
      AC.get('confirmPassword').setErrors(null); // Clear error when they match
    }
    
    // if(password == oldPassword) {
    //   AC.get('password').setErrors({ 
    //     matchOldPassword: true 
    //   });
    // }
    
  }

}